export const SALES_MACHINE_DEMO_URL =
  'https://app.howdygo.com/share/9fd596cc-fcd0-4184-80b0-f63cb3e245a1'
